import React from 'react';
import Message from '../../../../components/Message/Message';
export var DefaultContent = function DefaultContent() {
  return /*#__PURE__*/React.createElement(Message, {
    error: true,
    header: "Something went wrong",
    content: "Please try again and if the problem persists, contact support.",
    "data-qa": "content-error-message",
    className: "error-message"
  });
};